module.exports = __webpack_public_path__ + "img/admin.1b7088fd.png";